// src/core/data/redux/store.ts
import { configureStore } from "@reduxjs/toolkit";
import commonSlice from "./commonSlice";
import themeSettingSlice from "./themeSettingSlice";
import profileReducer from "./profileDetails";
import rolesPermissionsReducer from "./rolesPermissionsOverview";

const store = configureStore({
  reducer: {
    commonSlice: commonSlice,
    themeSetting: themeSettingSlice,
    profile: profileReducer,
    rolesPermissions: rolesPermissionsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
  